import { Controller } from '@hotwired/stimulus'

// Abstract base (not registered): shared drag/paste mechanics for upload dropzones.
export class PasteDropUploaderBase extends Controller {
  #dragDepth = 0

  handleDragOver (event) {
    event.preventDefault()
  }

  handleDragEnter (event) {
    event.preventDefault()
    this.#dragDepth += 1
    event.currentTarget.classList.add('upload_zone--dragging')
  }

  handleDragLeave (event) {
    this.#dragDepth -= 1
    if (this.#dragDepth > 0) return

    this.resetDragState(event)
  }

  resetDragState (event) {
    this.#dragDepth = 0
    event.currentTarget.classList.remove('upload_zone--dragging')
  }

  pasteTargetsEditable (event) {
    const target = event.target

    return !!target && typeof target.matches === 'function' && target.matches(':read-write')
  }

  fileFromClipboard (clipboardData, matchesType) {
    if (!clipboardData) return null

    const item = Array
      .from(clipboardData.items || [])
      .find((item) => item.kind === 'file' && matchesType(item.type))

    return item?.getAsFile() || null
  }

  showPasteError (message) {
    if (!this.hasPasteErrorTarget) return

    this.pasteErrorTarget.textContent = message
    this.pasteErrorTarget.classList.remove('hidden')
  }

  clearPasteError () {
    if (!this.hasPasteErrorTarget) return

    this.pasteErrorTarget.textContent = ''
    this.pasteErrorTarget.classList.add('hidden')
  }
}
